<template>
  <div>
    <h3 class="var-header">Variables</h3>

    <!-- <v-container fluid class="tab-container"> -->
    <div class="tab-container">
      <!-- Left Side: Stacked Tab Menu -->
      <div class="left-menu">
        <v-tabs v-model="activeTab" vertical class="stacked-tabs">
          <v-tab v-for="(tab, index) in tabs" :key="index">
            <v-icon left>{{ tab.icon }}</v-icon>
            {{ tab.label }}
          </v-tab>
        </v-tabs>
      </div>

      <!-- Right Side: Tab Content -->
      <div class="right-menu">
        <v-tabs-items v-model="activeTab">
          <v-tab-item v-for="(tab, index) in tabs" :key="index">
            <v-card class="tab-content">
              <!-- Custom Select for List ID -->
              <div
                v-if="tab.label === 'Lists Id'"
                class="custom-select-container"
              >
                <label class="select-label">Choose List:</label>
                <div class="custom-dropdown">
                  <select v-model="selectedList" class="custom-select">
                    <option
                      v-for="list in lists"
                      :key="list.id"
                      :value="list.id"
                    >
                      {{ list.name }}
                    </option>
                  </select>
                </div>
                <p class="sub-head">List Id</p>
                <v-sheet class="custom-input-container">
                  <!-- Non-editable input field -->
                  <input
                    v-model="selectedList"
                    type="text"
                    class="custom-input"
                    readonly
                  />
                  <!-- Attached button -->
                  <button class="custom-button" @click="copy(selectedList)">
                    <v-icon size="22" color="white">mdi-content-copy</v-icon>
                  </button>
                </v-sheet>
              </div>

              <!-- Company Id-->
              <div
                v-if="tab.label === 'Company Id'"
                class="custom-select-container"
              >
                <!-- <label class="select-label">Choose Lists:</label>
                            <div class="custom-dropdown">
                                <select v-model="selectedList" class="custom-select">
                                    <option v-for="list in lists" :key="list.id" :value="list.id">
                                        {{ list.name }}
                                    </option>
                                </select>
                            </div> -->
                <p class="sub-head">Company Id</p>
                <v-sheet class="custom-input-container">
                  <!-- Non-editable input field -->
                  <input
                    v-model="companyDetails.id"
                    type="text"
                    class="custom-input"
                    readonly
                  />
                  <!-- Attached button -->
                  <button
                    class="custom-button"
                    @click="copy(companyDetails.id)"
                  >
                    <v-icon size="22" color="white">mdi-content-copy</v-icon>
                  </button>
                </v-sheet>
              </div>

              <!-- Teams Id -->
              <div
                v-if="tab.label === 'Teams Id'"
                class="custom-select-container"
              >
                <label class="select-label">Choose Team:</label>
                <div class="custom-dropdown">
                  <select v-model="choosedTeam" class="custom-select">
                    <option
                      v-for="team in allTeams"
                      :key="team.id"
                      :value="team.id"
                    >
                      {{ team.name }}
                    </option>
                  </select>
                </div>
                <p class="sub-head">Team Id</p>
                <v-sheet class="custom-input-container">
                  <!-- Non-editable input field -->
                  <input
                    v-model="choosedTeam"
                    type="text"
                    class="custom-input"
                    readonly
                  />
                  <!-- Attached button -->
                  <button class="custom-button" @click="copy(choosedTeam)">
                    <v-icon size="22" color="white">mdi-content-copy</v-icon>
                  </button>
                </v-sheet>
              </div>

              <!-- Agent Id -->
              <div
                v-if="tab.label === 'Agents Id'"
                class="custom-select-container"
              >
                <label class="select-label">Choose Agent:</label>
                <div class="custom-dropdown">
                  <select v-model="selectedAgent" class="custom-select">
                    <option
                      v-for="item in agents"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <p class="sub-head">Agent Id</p>
                <v-sheet class="custom-input-container">
                  <!-- Non-editable input field -->
                  <input
                    v-model="selectedAgent"
                    type="text"
                    class="custom-input"
                    readonly
                  />
                  <!-- Attached button -->
                  <button class="custom-button" @click="copy(selectedAgent)">
                    <v-icon size="22" color="white">mdi-content-copy</v-icon>
                  </button>
                </v-sheet>
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <!-- Snackbar for Copy Confirmation -->
        <v-snackbar
          v-model="snackbar"
          :bottom="true"
          :right="true"
          timeout="2000"
        >
          Copied!
        </v-snackbar>
      </div>
    </div>
  </div>
  <!-- </v-container> -->
</template>

<script>
import { mapGetters, mapState } from "vuex";
const _ = require("lodash");
export default {
  data() {
    return {
      activeTab: 0, // Default selected tab
      tabs: [
        {
          label: "Lists Id",
          icon: "mdi-view-dashboard",
          content: "This is the Dashboard section.",
        },
        {
          label: "Company Id",
          icon: "mdi-account",
          content: "This is the Profile section.",
        },
        {
          label: "Agents Id",
          icon: "mdi-cog",
          content: "This is the Settings section.",
        },
        {
          label: "Teams Id",
          icon: "mdi-chart-bar",
          content: "This is the Reports section.",
        },
      ],
      lists: [],
      selectedList: "",
      listId: "",
      snackbar: false,
      // teams: []
      // selectedTeam: "",
      allTeams: [],
      choosedTeam: "",
      agents: [],
      selectedAgent: "",
    };
  },
  computed: {
    ...mapGetters([
      "ENDPOINT",
      "user",
      "dispoList",
      "fieldList",
      "teams",
      "selectedTeam",
      "companyDetails",
    ]),
  },
  mounted() {
    this.fetchLists();
    this.getAllAccounts();
    console.log("company Details: ", this.companyDetails);
  },
  methods: {
    copy(link) {
      const self = this;
      this.$copyText(link).then(
        function(e) {
          self.snackbar = true;
          console.log(e);
        },
        function(e) {
          console.log(e);
        },
      );
    },
    async getAllAccounts() {
      try {
        const getTeams = this.getTeamIds();
        const getAgents = await this.$http.post(
          `${this.$store.state.ENDPOINT}/accounts/fetch-v2`,
          {
            teams: getTeams,
            search: "",
          },
        );
        console.log("getAgents: ", getAgents.body);
        this.agents = getAgents.body;
        this.selectedAgent = this.agents[0].id;
      } catch (error) {
        console.log("Unable to fetch agents: ", error);
      }
    },
    /** recieve teams and lists array of ids */
    getTeamIds() {
      var teams = [];
      if (this.selectedTeam == "allTeams") {
        teams = _.map(this.teams, "id");
      } else {
        teams.push(this.selectedTeam);
      }

      teams = _.map(this.teams, "id");

      teams = _.without(teams, "allTeams");

      console.log("teams: ", this.teams);

      this.allTeams = this.teams.filter((team) => team.id !== "allTeams");
      this.choosedTeam = this.allTeams[0].id;

      console.log("allteams: ", this.allTeams);

      return teams;
    },
    getListIds() {
      var lists = [];
      if (this.selectedList == "allLists") {
        lists = _.map(this.lists, "id");
        // lists = []
      } else if (this.selectedList != "") {
        lists.push(this.selectedList);
      }

      lists = _.without(lists, "allLists");
      return lists;
    },
    // Fetch lists
    async fetchLists() {
      try {
        this.lists = [];
        var response = [];

        var teamIds = this.getTeamIds();

        // Teams sections
        response = await this.$http.post(`${this.ENDPOINT}/lists/fetch`, {
          teams: teamIds,
        });
        this.lists = response.body;

        console.log("Lists fetched: ", this.lists);

        if (this.lists.length < 1) {
          this.loader = false;
          return;
        }

        // this.lists.push({
        //     id: "allLists",
        //     name: "All Lists",
        // });

        // Here Check has any Store Saved SelectedList & Assign to Store Selected List
        if (this.storeSelectList != "") {
          let findList = _.find(this.lists, (l) => {
            return l.id == this.storeSelectList;
          });
          this.selectedList = this.lists.length > 0 ? this.lists[0].id : "";
          if (findList) {
            this.selectedList = findList.id;
          }
        }

        if (
          _.filter(this.lists, (d) => {
            return this.selectedList.toString() === d.id.toString();
          }).length < 1 &&
          this.storeSelectList == ""
        ) {
          this.selectedList = this.lists.length > 0 ? this.lists[0].id : "";
        }
      } catch (e) {
        this.loader = false;
        console.log("error in list fetch", e);
      }
    },
  },
};
</script>

<style scoped>
.sub-head {
  margin-block: 1rem;
  font-weight: 600;
}

/* Container */
.tab-container {
  /* height: ; */
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  /* background: #f5f5f5; */
}

/* Left Stacked Tabs */
.left-menu {
  background: white;
  padding: 10px;
  border-radius: 8px;
  /* margin-inline: 1rem; */
  width: 30%;
}

.right-menu {
  width: 70%;
}

.stacked-tabs {
  height: 100%;
}

/* Tab Content */
.tab-content {
  padding-inline: 1rem;
  /* min-height: 60vh; */
  background: white;
  border-radius: 8px;
}

/* Custom Select Styling */
.custom-select-container {
  margin-top: 15px;
}

.select-label {
  font-weight: 600;
  margin-bottom: 5px;
  display: block;
}

.custom-dropdown {
  position: relative;
}

.custom-select {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: white;
  cursor: pointer;
  appearance: none;
}

.custom-select:focus {
  border-color: #007bff;
  outline: none;
}

.custom-input-container {
  display: flex;
  align-items: center;
  width: 100%;
  /* Adjust width as needed */
  border: 1px solid #000000;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f9f9f9;
  margin-block: 1rem;
}

/* Non-editable input */
.custom-input {
  flex: 1;
  padding: 10px;
  border: none;
  background: transparent;
  outline: none;
  font-size: 16px;
}

/* Button */
.custom-button {
  background-color: #4caf50;
  color: white;
  padding: 10px 16px;
  border: none;
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
}

.var-header {
  padding: 1rem 2rem;
}

.v-tabs-items {
  border-radius: 12px !important;
}

/* Responsive - Full Width Tabs on Small Screens */
@media (max-width: 768px) {
  .left-menu {
    width: 100%;
  }

  .right-menu {
    width: 100%;
  }

  .tab-container {
    flex-direction: column;
  }

  .stacked-tabs {
    flex-direction: row;
    overflow-x: auto;
  }
}

/* Dark Theme Styles */
.theme--dark .var-header {
  color: #e0e0e0 !important;
}

.theme--dark .left-menu {
  background: #1e1e1e !important;
}

.theme--dark .tab-content {
  background: #1e1e1e !important;
}

.theme--dark .select-label,
.theme--dark .sub-head {
  color: #e0e0e0 !important;
}

.theme--dark .custom-select {
  background: #2d2d2d !important;
  border-color: #404040 !important;
  color: #e0e0e0 !important;
}

.theme--dark .custom-select option {
  background: #2d2d2d !important;
  color: #e0e0e0 !important;
}

.theme--dark .custom-input-container {
  background-color: #2d2d2d !important;
  border-color: #404040 !important;
}

.theme--dark .custom-input {
  color: #e0e0e0 !important;
}

.theme--dark .v-tab {
  color: #a0a0a0 !important;
}

.theme--dark .v-tab--active {
  color: #4ade80 !important;
}

.theme--dark .v-tabs-items {
  background: #1e1e1e !important;
}

.theme--dark .v-card.tab-content {
  background: #1e1e1e !important;
}
</style>
